/**
 * @generated SignedSource<<b0330051c07b16fbae2ed31cd76411cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateAlertPreferencesInput = {
  costAlertEnabled: boolean;
  costThreshold: number;
  errorAlertEnabled: boolean;
  piiEnabled: boolean;
  systemHealthAlertEnabled: boolean;
};
export type SettingsAlertsPageUpdateAlertsMutation$variables = {
  input: UpdateAlertPreferencesInput;
};
export type SettingsAlertsPageUpdateAlertsMutation$data = {
  readonly updateAlertPreferences: {
    readonly success: boolean;
  };
};
export type SettingsAlertsPageUpdateAlertsMutation = {
  response: SettingsAlertsPageUpdateAlertsMutation$data;
  variables: SettingsAlertsPageUpdateAlertsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateAlertPreferencesPayload",
    "kind": "LinkedField",
    "name": "updateAlertPreferences",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsAlertsPageUpdateAlertsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsAlertsPageUpdateAlertsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a60bab04c22ad9787a074595bc58bb12",
    "id": null,
    "metadata": {},
    "name": "SettingsAlertsPageUpdateAlertsMutation",
    "operationKind": "mutation",
    "text": "mutation SettingsAlertsPageUpdateAlertsMutation(\n  $input: UpdateAlertPreferencesInput!\n) {\n  updateAlertPreferences(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "0dbe667d1ed2a68b39f3ca4ec346d578";

export default node;
